import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';

class TextUtil {
  static capitalCase(text: unknown): string {
    if (typeof text !== 'string') return '';

    return _startCase(_toLower(text));
  }

  static toAllUpperCase(text?: unknown): string {
    if (!text || typeof text !== 'string') return '';

    return text.toUpperCase();
  }

  static removeSubStr(text?: unknown, subStrToRemove = '', replaceStr = ''): string {
    if (!text || typeof text !== 'string') return '';

    return text.replace(subStrToRemove, replaceStr).trim();
  }
}

export default TextUtil;
